<template>
  <p>
    <span v-if="$store.state.ui.isUpdating === true">
      <i class="fa fa-refresh fa-spin fa-fw"></i>
      {{ $t("content.updating_assets") }}
    </span>
    <span
      v-else-if="
        lastUpdatedInSeconds.seconds < 5 && lastUpdatedInSeconds.minutes <= 0
      "
      >{{ $t("content.updated_now") }}</span
    >
    <span v-else-if="lastUpdatedInSeconds.minutes < 1">{{
      $t("content.last_update", { time: lastUpdatedInSeconds.seconds })
    }}</span>
    <span v-else>{{
      $t("content.last_update_minutes", {
        seconds: lastUpdatedInSeconds.seconds,
        minutes: lastUpdatedInSeconds.minutes,
      })
    }}</span>
  </p>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "LastUpdated",
  data() {
    return {
      timerInterval: null,
      now: new Date(),
    };
  },
  computed: {
    lastUpdatedInSeconds() {
      return {
        minutes: Math.floor((this.now - Date.parse(this.lastUpdated)) / 60000),
        seconds:
          Math.ceil((this.now - Date.parse(this.lastUpdated)) / 1000) -
          Math.floor((this.now - Date.parse(this.lastUpdated)) / 60000) * 60,
      };
    },
    ...mapGetters({
      isUpdating: "coinmarketcap/requestInProcess",
      lastUpdated: "coinmarketcap/lastUpdated",
    }),
  },
  methods: {
    updateLastUpdateLabel() {
      this.now = new Date();
    },
  },
  mounted() {
    this.timerInterval = setInterval(this.updateLastUpdateLabel, 1000);
  },
  beforeDestroy() {
    clearInterval(this.timerInterval);
  },
};
</script>
